module.exports = __webpack_public_path__ + "assets/img/helmet.08f5591d.svg";